import { SelectBox } from 'macaron-frontend-ui'
import { useCallback } from 'react'
import { useSendClickEvent } from '~/navigation'
import {
  useCalendarQueryStatus,
  useChangeVisitorsCount,
  useIsCleared,
  useVisitorsCount,
  useVisitorsCountOptions,
} from '~/stores/calendar/state'
import { SelectBoxLoading } from './SelectBoxLoading'

export function VisitorsCount() {
  const { isLoading, ...props } = useVisitorsCountSelection()
  if (isLoading) {
    return <SelectBoxLoading />
  }
  return <SelectBox {...props} width={230} />
}

const CLEAR_LABEL = '未定'

function useVisitorsCountSelection() {
  const selectedCount = useVisitorsCount()
  const countOptions = useVisitorsCountOptions()
  const status = useCalendarQueryStatus()
  const changeCount = useChangeVisitorsCount()
  const isCleared = useIsCleared()
  const sendClickEvent = useSendClickEvent()
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value
      if (value === CLEAR_LABEL) {
        return
      }

      sendClickEvent({
        inventoryCalendar: 'visitorsCount',
        click_event: 'newReservationFlow/inventoryCalendar/visitorsCount',
      })

      // TODO: SelectBox の実装を見直して、素直に value から値がとれるように
      const count = parseInt(value.replace(/名$/, ''))
      changeCount(count)
    },
    [changeCount, sendClickEvent]
  )

  if (status === 'pending') {
    return { values: [], value: '', onChange: nop, disabled: true, isLoading: true }
  }

  const values = countOptions.map((count) => (count === undefined ? CLEAR_LABEL : `${count}名`))
  const value = isCleared ? CLEAR_LABEL : `${selectedCount}名`
  return { values, value, onChange, disabled: false, isLoading: false }
}

function nop() {}
